export const ROUTES = {
  LOGIN:          '/login',
  FORGOT_PASSWORD:'/forgot-password',
  RESET_PASSWORD: '/auth/reset-password',
  DASHBOARD:      '/',
  USERS:          '/users',
  USER_DETAIL:    '/users/:id',
  VENDORS:        '/vendors',
  VENDOR_DETAIL:  '/vendors/:id',
  CATEGORIES:     '/categories',
  BRANDS:         '/brands',
  PRODUCTS:       '/products',
  PRODUCTS_IMPORT:'/products/import',
  PRODUCT_NEW:    '/products/new',
  PRODUCT_DETAIL: '/products/:id',
  ORDERS:         '/orders',
  ORDER_DETAIL:   '/orders/:orderNumber',
  SHIPPING:       '/shipping',
  SHIPMENTS:      '/shipments',
  PROMOTIONS:     '/promotions',
  REVIEWS:        '/reviews',
  NOTIFICATIONS:  '/notifications',
  ANALYTICS:      '/analytics',
  PAYOUTS:        '/payouts',
  RETURNS:        '/returns',
  // CHAT:           '/chat', // CHAT_DISABLED
  PLANS:          '/plans',
  SETTINGS:       '/settings',
  LOYALTY:        '/loyalty',
  ACTIVITY_LOGS:  '/activity-logs',
  BANNERS:        '/banners',
  BLOG:           '/blog',
  EARLY_REGISTRATIONS: '/early-registrations',
}
